<template>
	<div class="content-finish">
	<!-- Validacion observacion-->
    <div class="order-out" v-show="exit_component">
      <div class="canceled-info">
        <i id="id_icons"></i>
        <h4>Su transacción fue enviada exitosamente</h4>
        <div class="exit-options">
          <button @click="aceptar()">Ok</button>
        </div>
      </div>
    </div>
  <!--- Fin Validacion-->

		<div style="padding: 0px;" class="mask" v-bind:style="{backgroundColor : color_botones }">
			<img src="https://info.vinapp.co/wp-content/uploads/2021/05/estrellas.png" alt="">
			<div class="check">
				<i class="fas fa-check" v-bind:style="{color : color_botones }"></i>
			</div>
		</div>
		<div class="data-finish">
			<div class="content-order">
				<h4>Estado: {{ form.estado }}</h4>
			</div>
			<div class="data-finish-client">
				<div class="both-data-finish">
					<h4>Nombre:</h4>
					<h5>{{ form.name }}</h5>
				</div>
				<!--<div class="both-data-finish">
					 <select class="select-icono" required="true" v-model="form.id_type_forma_pago" style="width: 125px;" disabled>        
		        <option value="0" selected disabled>Seleccione una forma de pago</option>
		        <option value="37" >Efectivo</option>
		        <option value="38" >Transferencia</option>
		        <option value="39" >Datáfono</option>
		        <option value="76" >Pago en Linea</option>
		        <option value="141" >Pago Nequi</option>
		        <option value="126" >Bancolombia</option>
		      </select>
           <input type="text" id="name" name="name" style="width: 105px;" v-model="form.valor_forma_pago">
				</div>-->

				<div class="both-data-finish">
					 <select class="select-icono" required="true" v-model="form.id_type_forma_pago" style="width: 125px; border-radius: 10px;">        
		        <option value="0" selected >Seleccione una forma de pago</option>
		        <!--<option value="76" >Pago en Linea</option>-->
		        <option value="141" >Pago Nequi</option>
		        <option value="126" >Bancolombia</option>
		      </select>
           <!--<input type="text" id="name" name="name" disabled style="width: 105px; border-radius: 10px;" v-model="form.valor_forma_pago_secundaria">-->
           <h4>{{ form.valor_forma_pago }}</h4>
				</div>

				<div class="both-data-finish">
					<div style="text-align: left;width:100%;padding-bottom: 10px;">
			      <input placeholder="Email" type="email" id="email" class="izquierda" autocomplete="off" required="true" v-model="form.email" style="width: 145px; border-radius: 10px;">      
			      <small id="validateEmail" style="color:red;display: none;">Campo email es obligatorio.</small>
			      <small id="validateEmail" style="color:red;display: none;">Debe introducir un email valido.</small>
			    </div>
				</div>

			</div>
			<div class="order-finish-client">
				<div class="order-finish-detail">
					<div class="options">
						<h4>Detalle de orden</h4>
					</div>
					<div class="products-order">
						<li v-for="item in form.details">{{item.name_product}}</li>
					</div>
				</div>
				<div class="finish-order-total">
					<h4>Total:</h4>
					<h5>$ {{ Intl.NumberFormat("de-DE").format(form.total) }}</h5>
				</div>
			</div>
		</div>	

		<div class="container-button">
	      <div class="send-button2">
	      	<button class="btn-wonpi" @click="pay()" v-show="form.id_type_forma_pago == '76' ">Paga Aquí 2</button>   
	        <button class="btn-wonpi" @click="payNequi()" v-show="form.id_type_forma_pago == '141' ">Paga Aquí</button>
	        <button class="btn-wonpi" @click="payBancolombia()" v-show="form.id_type_forma_pago == '126'">Paga Aquí</button>
	      </div>
    </div>

	</div>
</template>
<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
	.content-finish{
		width: 100%;
		height: auto;
		padding-bottom: 20px;
	}
	.mask{
		padding: 20px 0px;
		width: 100%;
		height: 45vh;
		/*border-bottom-left-radius: 120px;
		border-bottom-right-radius: 120px;*/
	}
	.mask img{
		width: 50%;
		animation: scala .7s ease-in-out;
	}
	.check{
		width: 62px;
		height: 62px;
		border-radius: 50%;
		background: #fff;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: -85px;	
	}
	.check i{
		font-size: 26px;
	}
	.title{
		padding-top: 35px;
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #fff;
		margin-bottom: 4px;
	}
	.subtitle{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #fff;
		padding: 10px;
	}
	.data-finish{
		border-radius: 10px;
		width: 80%;
		height: auto;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 8px 10px 0px rgba(215,215,215,1);
		margin-top:-75px;
	}
	.content-order{
		border-bottom: 1px solid #f2f2f2;
		padding-top: 25px;
		padding-bottom: 10px;
	}
	.content-order h4{
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #000;
		margin-bottom: 4px;
	}
	.content-order h5{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
		margin-bottom: 2px;
	}
	.data-finish-client{
		width: 100%;
		height: auto;
		padding: 5px 0px;
		border-bottom: 1px solid #f2f2f2;
	}
	.both-data-finish{
		width: 100%;
		height: auto;
		padding: 5px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.both-data-finish h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}
	.both-data-finish h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}
	.finish-order-total{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.order-finish-detail{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		border-bottom: 1px solid #f2f2f2;
		transition: all .3s ease-in-out;
	}
	.options{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.products-order{
		width: 100%;
		text-align: left;
		padding-left: 15px;
		padding-top: 10px;
		transition: all 3s ease-in-out;
	}
	.products-order li{
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}
	.order-finish-detail h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
		margin-bottom: 0;
	}
	.order-finish-detail i{
		margin-right: 5px;
		cursor: pointer;
	}
	.cart-finish-detail{
		width: 100%;
	}
	.height{
		height: 0px !important;
		overflow: hidden;
	}
	.finish-order-total h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}
	.finish-order-total h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}
	.button-back-to-home button{
		padding: 10px 25px;
		background:transparent;
		font-size: 17px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		border-radius: 5px;
	}
	.button-back-to-home button:focus{
		outline: none !important;
	}
	.button-back-to-home i{
		margin-right: 8px;
	}
	.rotate{
		transform: rotate(180deg);
	}
	@keyframes scala {
		from{
			transform: scale(0);
		}
		to{
			transform: scale(1);
		}
	}
	.container-button{
      width: 95%;
      padding: 10px 0px 10px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }
    .send-button{
      width: 100%;
      background: #64B161;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button i:nth-child(1){
      color: #0DC142;
    }

    .send-button i:nth-child(2){
      color: #fff;
      margin-right: 6px;
    }

    .btn-wonpi{
      display: inline-block;
        height: 40px;
        line-height: 40px;
        background-color: rgb(26, 69, 148);
        border: 0px;
        border-radius: 10px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 600;
        font-size: 16px;
        padding: 0px 16px;
        color: white;
        cursor: pointer;
        -webkit-font-smoothing: subpixel-antialiased;
        width: 100%;
    }
    .btn-wonpi::before {
      content: "";
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image : url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 229.5 229.5'%3E%3Cpath fill='%23fff' d='M214.419 32.12A7.502 7.502 0 0 0 209 25.927L116.76.275a7.496 7.496 0 0 0-4.02 0L20.5 25.927a7.5 7.5 0 0 0-5.419 6.193c-.535 3.847-12.74 94.743 18.565 139.961 31.268 45.164 77.395 56.738 79.343 57.209a7.484 7.484 0 0 0 3.522 0c1.949-.471 48.076-12.045 79.343-57.209 31.305-45.217 19.1-136.113 18.565-139.961zm-40.186 53.066l-62.917 62.917c-1.464 1.464-3.384 2.197-5.303 2.197s-3.839-.732-5.303-2.197l-38.901-38.901a7.497 7.497 0 0 1 0-10.606l7.724-7.724a7.5 7.5 0 0 1 10.606 0l25.874 25.874 49.89-49.891a7.497 7.497 0 0 1 10.606 0l7.724 7.724a7.5 7.5 0 0 1 0 10.607z'/%3E%3C/svg%3E");
      background-size:contain;
      background-repeat: no-repeat;
      vertical-align: middle;
      margin-right: 8px;
      transform: translateY(-2px);
    }

    .send-button2{
      width: 100%;
      background: #1A4594;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button2 label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button2 i:nth-child(1){
      color: #1A4594;
    }

    .send-button2 i:nth-child(2){
      color: #fff;
      margin-right: 6px;
    }

    .order-out{
      width: 100%;
      height: 110vh;
      position: fixed;
      top: 0;
      background-color: rgba(0, 0, 0, .6);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .canceled-info{
      background: #fff;
      width: 80%;
      margin: 0 auto;
      padding-top: 20px;
      text-align: center;
      display: block;
      border-radius: 10px;
    }

    .canceled-info i{
      color: #E43A3A;
      font-size: 29px;
    }

    .canceled-info h4{
      font-family: 'Poppins', sans-serif;
      font-size: 17px;
      font-weight: 500;
      padding-top: 14px;
    }

    .canceled-info button{
      width: 100%;
      border-bottom: none;
      border-left: none;
      border-right: none;
      background: transparent;
      border-top: 1px solid #E8E8E8;
      margin-top: 10px;
      padding-top: 15px;
      padding-bottom: 15px;
      font-family: 'Poppins', sans-serif;
    }

    .exit-options{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  [disabled] {
    opacity: 0.0;
  }
</style>
<script>
import Vue from 'vue'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import axios from 'axios';
export default {
	data() {
		return {
			color_botones: "#d0062f",
			statusValidation:false,
			exit_component:false,
		  listFormaPago:[{id:37,value:'Efectivo', cantidad: 0},{id:38,value:'Transferencia', cantidad: 0},{id:39,value:'Datáfono', cantidad: 0},{id:141,value:'Nequi', cantidad: 0},{id:126,value:'Bancolombia', cantidad: 0},{id:148,value:'Rappi', cantidad: 0},{id:76,value:'Pago en linea', cantidad: 0}],
		  form:{
		  }
		}	
	},
	methods:{
		validarCampos(){     
      this.statusValidation = true;
      if(!this.form.email){           
        this.statusValidation = false;
        document.getElementById("validateEmail").style.display = "block";
      }
    },
    aceptar(){
      location.href = location.origin+'/'+this.form.uri.uri
    },
    pay(){
	    this.validarCampos()
	    if(!this.statusValidation) return 0;   
	    var self = this;
	    axios
	    .get('https://back.vinapp.co/api/order/get-data-wompi/'+this.company.id)
	    .then( res =>{
	      this.formPay.wompiPublicKey = res.data.wpk;
	      this.formPay.wompiCurrency = res.data.wc;
	      this.formPay.wompiReference = res.data.wr;
	      this.formPay.redirectUrl = res.data.wp_redirect_url;
	      self.checkout = new WidgetCheckout({
	        currency: self.formPay.wompiCurrency,
	        amountInCents: parseFloat(String(self.total)+'00'),
	        reference: self.formPay.wompiReference,
	        publicKey: self.formPay.wompiPublicKey,
	        redirectUrl: `${window.location.origin}${self.formPay.redirectUrl}${self.formPay.wompiReference}`
	      });
	      self.executeWompi();
	    })
	    .catch( err => {
	      console.log(err);
	    });
	    
	  },
	  executeWompi(){
	    var self = this;
	    self.saveOrderBD(true,this.formPay.wompiReference,true);
	    this.checkout.open(function ( result ) { 
	      var transaction = result.transaction
	      if(transaction.status == 'APPROVED'){
	          self.enviarWhatsApp(true,transaction.id);
	      }else{
	          self.form.id_type_forma_pago = 0;
	          self.checkout = false; 
	      }
	     
	    });
	  },
    payNequi(){
    	  this.validarCampos()
    	  if(!this.statusValidation){ 
          return 0;
        } 
        this.form['telefono_nequi'] = this.form.phone;
        this.form['telefono'] = this.form.phone;
        this.form['nombres'] =  this.form.address;
        this.form['direccion'] =  this.form.name;

        this.form['tipo_transaccion'] = "NEQUI";

        axios.post('https://back.vinapp.co/api/transactions/save-transaction-v2', this.form)
        .then(res => {
            console.log(res.data);  
            if(res.data.error == false){
            	this.exit_component = true
            }else{
              alert(res.data.message)
            }
            this.submitSaveOrder = true; 
        })
        .catch(err => {
          this.submitSaveOrder = true; 
          console.log(err);      
        });
      
   },
   payBancolombia(){
        this.validarCampos()
        if(!this.statusValidation){ 
          return 0;
        } 

        this.form['id_plan_sucursal'] = "Compra establecimiento";
        this.form['tipo_transaccion'] = "BANCOLOMBIA";
        this.form['telefono'] = this.form.phone;
        this.form['nombres'] =  this.form.address;
        this.form['direccion'] =  this.form.name;
        this.form['async_payment_url'] = location.origin+'/'+this.form.uri.uri+'/order-v2';


        axios.post('https://back.vinapp.co/api/transactions/save-transaction-v2', this.form)
        .then(res => {
            console.log(res.data);  
            if(res.data.error == false){
              location.href = res.data.data.url;

            }else{
              alert(res.data.message)
            } 
        })
        .catch(err => {
          this.submitSaveOrder = true; 
          console.log(err);      
        });
      
   },
    UpdateWayToPay(){
      //alert("Carmen Cachona");
    },
		setupOrder() {
		 var id = this.$route.params.id;
			axios.post('https://back.vinapp.co/api/company/get-data-order-pay',{id_order: id})
				.then(res => { 
					if (res.data) {
						this.form = res.data
						this.form.id_type_forma_pago = 141;
						this.form.valor_forma_pago = this.form.total;
					}
      }).catch(err => {
        console.log(err);      
      });
		},
	
	},
	mounted() { 
		this.setupOrder()
	}
}
</script>